import { useEffect, useState } from "react";
import { Generico } from "../../components/Generico";
import { FuncionalidadMenu } from "../../models/administracion/FuncionalidadMenu";
import { useForm } from "react-hook-form";
import { useToken } from "../../components/useToken";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { InputComponent } from "../../components/InputComponent";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { MenuPermisoSeleccion } from "./MenuPermisoSeleccion";

export const Funcionalidad = ({ idp, toast, generic, permss }) => {
    const omodel = new FuncionalidadMenu();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue, watch } = useForm({ defaultValues, shouldTrim: true });
    const [registers, setRegisters] = useState(null);
    const { getRol } = useToken();
    const monitoreoService = new MonitoreoService();
    const [item, setItem] = useState(null);
    const [dialogFuncion, setDialogFuncion] = useState(false);
    const [dialogPermiso, setDialogPermiso] = useState(false);
    const permiso = watch('permiso');
    const { table, setLoading, setTotalRecords, lazyParams, inDrop, inText } = InputComponent({ registers, omodel, generic, errors, control, permss, id: getValues('id') });

    const loadLazyData = () => {
        setLoading(true);
        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        _lazyParams.idp = idp;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        monitoreoService.listado('admin/funcion-menu/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegisters(res.data.registros);
            setLoading(false);
        });
    }

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const edit = () => {
        monitoreoService.consultar(item?.id, 'admin/funcion-menu/consulta').then(res => {
            const _item = res.data;
            reset(generic.renewValues(_item, omodel.model));
            setDialogFuncion(true);
        });
    }

    const deleteItem = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la funcionalidad?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    }

    const eliminar = () => {
        monitoreoService.eliminar(item?.id, 'admin/funcion-menu/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { edit() } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { deleteItem() } });

        return [{ label: 'Opciones', items: items }];
    }

    const openNew = () => {
        setDialogFuncion(true);
        reset(defaultValues);
    }

    const onSubmit = (data) => {
        data.idp = idp;

        const request = getValues('id') == null ? monitoreoService.nuevo(data, 'admin/funcion-menu/nuevo') : 
            monitoreoService.editar(data, 'admin/funcion-menu/editar');
        request.then(res => {
            setDialogFuncion(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Por favor complete los campos requeridos', life: 3000 });
    };

    return (
        <>
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, '', permss)}></Toolbar>
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Card>

            <Dialog visible={dialogFuncion} header={getValues('id') == null ? "Nuevo" : "Editar: " + item?.nombre} modal className="p-fluid modal-ssize"
                onHide={e => setDialogFuncion(false)} style={{ maxWidth: '400px' }} >
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="formgrid grid">
                        {inText('nombre', {}, 12)}
                        {inDrop('estado', generic.estados, { lab: omodel.optionLabel }, 12)}
                        {inText('codigo', {}, 12)}
                        {inDrop('permiso', permiso ? [permiso] : [], { lab: omodel.optionLabel, ne: true, showClear: false }, 10)}
                        <div className="field col-2" style={{ paddingTop: '1.8rem' }}>
                            <Button icon="pi pi-search" type="button" className="p-button-warning" title="Seleccionar permiso" onClick={() => setDialogPermiso(true)} />
                        </div>
                    </div>
                    {generic.buttonsForms(setDialogFuncion)}
                </form>
            </Dialog>

            <Dialog visible={dialogPermiso} header="Seleccionar permiso" modal className="p-fluid modal-ssize"
                onHide={e => setDialogPermiso(false)} style={{ maxWidth: '1000px' }} >
                <MenuPermisoSeleccion id={idp} toast={toast} seleccionado={permiso}
                    onAceptar={(sel) => { setValue('permiso', sel, { shouldDirty: true, shouldValidate: true }); setDialogPermiso(false); }}
                    onCancelar={() => setDialogPermiso(false)} />
            </Dialog>
        </>
    )
}
